var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 189,
    height: 177,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 189,
    height: 177
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.9997 89.2901C80.8244 7.3764 181.641 30.3823 194.999 110.29L169.499 110.29C168.537 53.8841 90.6463 13.2384 51.9997 89.2901Z",
    stroke: "#000000",
    transform: "matrix(1.00003 0 0 1 -16.001 -22.9987)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.999 110.499C154.999 135.628 134.628 155.999 109.499 155.999 84.3706 155.999 63.9996 135.628 63.9996 110.499 63.9996 85.3706 84.3706 64.9996 109.499 64.9996 134.628 64.9996 154.999 85.3706 154.999 110.499Z",
    fill: "#42AECC",
    transform: "matrix(1.00003 0 0 1 -16.001 -22.9987)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.999 130.999C137.174 212.913 36.3577 189.907 22.9999 109.999L48.4997 109.999C49.4616 166.405 127.352 207.051 165.999 130.999Z",
    stroke: "#77A02E",
    fill: "#77A02E",
    transform: "matrix(1.00003 0 0 1 -16.001 -22.9987)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.999 109.999C133.999 123.254 123.254 133.999 109.999 133.999 96.7446 133.999 85.9995 123.254 85.9995 109.999 85.9995 96.7446 96.7446 85.9995 109.999 85.9995 123.254 85.9995 133.999 96.7446 133.999 109.999Z",
    transform: "matrix(1.00003 0 0 1 -16.001 -22.9987)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.999 95.4995C104.999 100.746 100.746 104.999 95.4995 104.999 90.2528 104.999 85.9995 100.746 85.9995 95.4995 85.9995 90.2528 90.2528 85.9995 95.4995 85.9995 100.746 85.9995 104.999 90.2528 104.999 95.4995Z",
    fill: "#FFFFFF",
    transform: "matrix(1.00003 0 0 1 -16.001 -22.9987)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.f7e1f197a835ac2bb23dccd26039e0f9.svg";
export { ForwardRef as ReactComponent };